var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextalign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.25016C5 4.60583 5.52233 4.0835 6.16667 4.0835H21.8333C22.4777 4.0835 23 4.60583 23 5.25016C23 5.89449 22.4777 6.41683 21.8333 6.41683H6.16667C5.52233 6.41683 5 5.89449 5 5.25016ZM5 22.7502C5 22.1058 5.52233 21.5835 6.16667 21.5835H15.8333C16.4777 21.5835 17 22.1058 17 22.7502C17 23.3945 16.4777 23.9168 15.8333 23.9168H6.16667C5.52234 23.9168 5 23.3945 5 22.7502ZM5 16.9168C5 16.2725 5.52233 15.7502 6.16667 15.7502H21.8333C22.4777 15.7502 23 16.2725 23 16.9168C23 17.5612 22.4777 18.0835 21.8333 18.0835H6.16667C5.52233 18.0835 5 17.5612 5 16.9168ZM5 11.0835C5 10.4392 5.52233 9.91683 6.16667 9.91683H15.8333C16.4777 9.91683 17 10.4392 17 11.0835C17 11.7278 16.4777 12.2502 15.8333 12.2502H6.16667C5.52234 12.2502 5 11.7278 5 11.0835Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextalign);
export default __webpack_public_path__ + "static/media/textalign.fb1e6f405c9f37053063f1318f81b08a.svg";
export { ForwardRef as ReactComponent };